import React, { useRef } from 'react'
import Reels from './Components/Reels';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { useEffect, useState } from "react"
import JackpotDisplay from './Components/JackpotDisplay';
import { AnimationSeqContextProvider } from './ContextProviders/AnimationSeqContextProvider';
import { useGameStateContext } from './ContextProviders/GameStateContextProvider';
import { Box, Typography, responsiveFontSizes, } from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import LineSelector from './Components/LineSelector';
import { AnimatePresence, motion } from "framer-motion";
import PlayCircleIcon from '@mui/icons-material/PlayCircle';

import { Fireworks } from '@fireworks-js/react'

import gameConfig from './gameConfig';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';

function GameView({ sound, devView }) {

  const gameState = useGameStateContext();
  const onPlay = () => {
    gameState.spin();
  }

  return (
    <div style={{
      position: 'relative',
      width: '100vw', height: '100vh',
      backgroundImage: `url(${process.env.PUBLIC_URL + '/Images/background.png'})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center bottom',
      backgroundRepeat: 'no-repeat'
    }}>

      {devView && (
        <Box
          sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', bgcolor: '#cfe8fc', height: '30px' }}>
          <Box >
            State: {gameState.state}
          </Box>
          <Box>
            <Button
              onClick={() => {
                document.documentElement.requestFullscreen();
              }}
            >Fullscreen
            </Button>

          </Box>
          <Box sx={{ pointerEvents: 'auto', position: 'relative', zIndex: 10 }}>
            Sim Win
            {Object.keys(gameConfig.colors.jackpots).map((jpName) => {
              return (
                <Button
                  key={"Sim" + jpName}
                  onClick={(e) => {
                    fetch("/api/simwin?jackpot=" + jpName);
                  }}
                >{jpName}
                </Button>
              );
            })}
          </Box>
        </Box>

      )}
      <div className="App" style={{
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      }}>
        <AnimationSeqContextProvider win={gameState.response.win} state={gameState.response}>
          <Box sx={{ width: '90vw', alignItems: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', aspectRatio: 16/9 }}>

            <Box id="upperPart" sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              background: `url(${process.env.PUBLIC_URL + '/Images/upperPart.png'}) no-repeat center center`,
              backgroundSize: '100% 100%',
              justifyContent: 'center',
              width: '55%',
              height: '21%',
              aspectRatio: 1
            }}>
              <JackpotDisplay jackpots={gameState.response.jackpots} sound={sound} />
            </Box>

            <Box
              sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', position: 'relative' }}
            >
              <Box
                id="sideLeft"
                className={gameState.state === 'Idle' ? '' : 'hidden'}
                sx={{
                  display: 'flex', flexDirection: 'row',/*bgcolor: '#cfe8fc',*/ position: 'absolute', left: -130, height: '100%',
                  background: `url(${process.env.PUBLIC_URL + '/Images/sideLeft.png'}) no-repeat center center`,
                  backgroundSize: '100% 70%',
                  backgroundPositionY: '20%',
                  pointerEvents: gameState.state === 'Idle' ? 'auto' : 'none',
                }}
                alignItems="center"
                justifyContent="center"
              >
                <Box sx={{ height: '100%', width: 200, display: 'flex', flexDirection: 'column', alignItems: 'center', pt: '85%' /* bgcolor: '#D8D8D8'*/ }}>
                  
                {/*}<Typography variant="h6" textAlign="left" sx={{ color: '#FFD700' }}>Lines:</Typography>{*/}
                  <FormGroup sx={{ gap: 0, mt: 2 }}>
                    {
                      Object.keys(gameConfig.lines).map((l, lidx) => (
                        <LineSelector lineName={l} lineCaption={"Line " + (lidx + 1)} linekey={lidx} key={lidx} />
                        //  <FormControlLabel key={lidx} control={<Checkbox defaultChecked checked={gameState.activeLines.includes(l)} onChange={(event) => { onActiveLineChanged(l, event.target.checked) }} />} label={l} />
                      ))
                    }
                  </FormGroup>
                </Box>
              </Box>
              <Box zIndex={2}>
                {/*}
                <div id="background" style={{
                  position: 'absolute',

                  width: '60px',
                  height: '40%',

                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',

                  background: 'linear-gradient(135deg, rgba(255, 0, 150, 0.7), rgba(0, 204, 255, 0.7))',

                  zIndex: 0
                }}> </div>
                
                {*/}
                <Reels symbols={gameState.symbols} spinning={gameState.state === 'spin1' || gameState.state === 'spin2'} matches={gameState.response.jackpotSymMatches} />
              </Box>
              <Box
                id="sideRight"
                sx={{
                  display: 'flex', flexDirection: 'row',/*bgcolor: '#cfe8fc',*/ position: 'absolute', right: -120, height: '100%',
                  background: `url(${process.env.PUBLIC_URL + '/Images/sideRight.png'}) no-repeat center center`,
                  backgroundSize: '100% 70%',
                  backgroundPositionY: '20%',
                }}
                alignItems="center"
                justifyContent="center"
              >
                <Box sx={{ height: '100%', width: 200, display: 'flex', flexDirection: 'column', alignItems: 'center', pt: '65%' /* bgcolor: '#D8D8D8'*/ }}>

                  <Typography variant="h6" textAlign="left" sx={{ color: '#FFD700' }}>Credit <br /> {Math.trunc(gameState.credit)}$</Typography>
                  {gameState.freeGames > 0 && (<Box sx={{ display: 'flex', /*bgcolor: '#E0E0E0',*/ m: 2, color: '#FFD700' }}>Free Games: {gameState.freeGames}</Box>)}
                  <Typography m={2} variant="h6" textAlign="left" sx={{ color: '#FFD700' }}>Costs: {gameState.turnCosts + '$'}</Typography>
                  <Box height='120px' key='boxPalyButton' sx={{ display: 'flex', flexDirection: 'column',/* bgcolor: '#EEEEEE',*/ m: 2, alignItems: 'center' }}>
                    <AnimatePresence>
                      {(gameState.state === 'Idle' || gameState.state === 'Second') && (
                        <motion.div
                          key='playButton'
                          initial={{ 'scale': 0.2 }}
                          animate={{ 'scale': 1.0 }}
                          exit={{ 'scale': 0.2 }}
                          whileHover={{ scale: 1.2, transition: { duration: 0.2, style: "spring" } }}
                          whileTap={{ scale: 1.1, transition: { duration: 0.1, style: "spring" } }}
                          transition={{ style: "spring" }}>
                          <Button onClick={() => gameState.spin()}>
                            <div>
                              <PlayCircleIcon style={{ color: 'green', fontSize: 80 }} />
                              <Typography m={0} variant="h6" textAlign="center" sx={{ color: '#FFD700' }}>
                                {gameState.state === 'Idle' ? "SPIN" : "2nd SPIN"}
                              </Typography>
                            </div>
                          </Button>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </AnimationSeqContextProvider>


      </div>
      <FullscreenAnimation sound={sound} />
    </div >
  );
}

function FullscreenAnimation({ sound }) {

  const [animActive, setAnimActive] = useState(false);
  const ref = useRef(null);
  var fullScreenTheme = createTheme({
    palette: {
      primary: { main: '#FFFFFF' }
    }
  });
  fullScreenTheme = responsiveFontSizes(fullScreenTheme);

  const gameState = useGameStateContext();
  const { money, freeGames } = gameState.response.win || { money: null, freeGames: null };
  if ((gameState.state == "winAnimationDisplay1" || gameState.state == "winAnimationDisplay2")) {
    console.log("Fullscrren Animation started");
    new Audio(`${process.env.PUBLIC_URL}/Sounds/winning.mp3`).play();
    setTimeout(() => {
      console.log("Fullscrren Animation finished");
      gameState.onAnimationFinished("Fullscreen")
    }, 10000);
    return (
      <motion.div
        className="fullscreen"
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.8 }}
        transition={{ duration: 0.8 }}
      >

        <Fireworks
          ref={ref}
          options={{
            intensity: 40,
            opacity: 0.3,
            sound: {
              enabled: sound,
              files: [
                'Sounds/explosion0.mp3',
                'Sounds/explosion1.mp3',
                'Sounds/explosion2.mp3'
              ],
              volume: {
                min: 4,
                max: 8
              }
            },
            lineWidth: {
              explosion: {
                min: 1,
                max: 7
              },
              trace: {
                min: 1,
                max: 2
              }
            }
          }}
          style={{
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            position: 'fixed',
          }}
        />
        <Box
          component={motion.div}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0,0,0,0.8)',
            borderRadius: 20,
            zIndex: 12
          }}
          initial={{ 'scale': 0 }}
          animate={{ 'scale': [null, 2.0, 1.0] }}
          transition={{
            style: "spring",
            stiffness: 500,
            duration: 1.2,
            delay: 1,
          }}
        >
          <ThemeProvider theme={fullScreenTheme}>
            <Typography variant="h2" m={5} display="block" sx={{ color: '#FFD700' }}>!! YOU WON !!</Typography>
            {money && (<Typography variant="h1" p={2} m={2} display="block" sx={{ color: '#FFD700' }}>{Math.trunc(money)}$</Typography>)}
            {money && freeGames && (<Typography variant="h1" display="block" sx={{ color: '#FFD700' }}>+</Typography>)}
            {freeGames && (<Typography variant="h2" p={2} m={2} display="block" sx={{ color: '#FFD700' }}>{freeGames} Free Games</Typography>)}
          </ThemeProvider>
        </Box>

      </motion.div>
    );
  }
}

export default GameView;
